/**
 * Textos (`ca`) del tall «training» de Qualitat i APPCC (OBR-170, formació de manipuladors). Tall propi: no es toca
 * `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const trainingCa = {
  'backoffice.qualityTraining': {
    // Columna i filtre de les llistes de l'Equip (Usuaris i Operaris).
    columnHeader: 'Formació',
    filterLabel: 'Formació',
    filterAll: 'Totes',
    rowAction: 'Formació',
    openFor: 'Formació de {{name}}',
    // Estat d'una persona (derivat de les dates, mai desat).
    statusValid: 'Vigent',
    statusExpiring: 'Caduca aviat',
    statusExpired: 'Caducada',
    statusMissing: 'Sense formació',
    // Temes.
    topicFoodHandler: 'Manipulador d’aliments',
    topicAllergens: 'Al·lèrgens',
    topicOther: 'Altres',
    // Diàleg de la persona.
    dialogTitle: 'Formació de {{name}}',
    dialogHint:
      'Cursos i certificats de la persona. L’estat el marca la formació que cobreix més temps; si alguna no caduca, sempre és vigent.',
    dialogStatus: 'Estat',
    empty: 'Encara no hi ha cap formació registrada.',
    loadError: 'No s’han pogut carregar les formacions.',
    readOnly: 'Només l’administració i qualitat poden registrar, editar o donar de baixa formacions.',
    add: 'Afegeix formació',
    edit: 'Edita',
    remove: 'Dona de baixa',
    // Una formació a la llista.
    rowTrainedOn: 'Feta el {{date}}',
    rowProvider: 'Entitat: {{provider}}',
    rowExpiresOn: 'Caduca el {{date}}',
    rowNoExpiry: 'No caduca',
    rowNoCertificate: 'Sense certificat',
    certificateOpen: 'Obre el certificat',
    certificateOpenError: 'No s’ha pogut obrir el certificat. Torna-ho a provar.',
    // Formulari.
    formTitleNew: 'Nova formació',
    formTitleEdit: 'Edita la formació',
    fieldTopic: 'Tema',
    fieldTopicLabel: 'Quina formació',
    fieldTopicLabelHint: 'Obligatori quan el tema és «Altres».',
    fieldTrainedOn: 'Data de la formació',
    fieldProvider: 'Entitat o formador',
    fieldExpiresOn: 'Caduca el',
    fieldExpiresOnHint: 'Data de renovació. Buida si la formació no caduca.',
    fieldCertificate: 'Certificat',
    fieldCertificateHint: 'PDF o imatge, fins a 10 MB.',
    certificateCurrent: 'Certificat adjunt',
    certificateNew: 'Nou: {{name}}',
    certificateRemove: 'Treu el certificat',
    fieldNotes: 'Notes',
    // Errors de validació i de xarxa (mai silenciats).
    errorTopicLabelRequired: 'Indica quina formació és.',
    errorTrainedOnRequired: 'Cal la data de la formació.',
    errorTrainedOnFuture: 'La data de la formació no pot ser futura.',
    errorDateInvalid: 'La data no és vàlida.',
    errorExpiresBeforeTrained: 'La caducitat no pot ser anterior a la data de la formació.',
    errorFileType: 'El certificat ha de ser un PDF o una imatge.',
    errorFileTooLarge: 'El certificat no pot passar de 10 MB.',
    errorUpload: 'No s’ha pogut pujar el certificat. Torna-ho a provar.',
    errorSave: 'No s’ha pogut desar la formació. Torna-ho a provar.',
    errorDelete: 'No s’ha pogut donar de baixa la formació. Torna-ho a provar.',
    // Baixa lògica (motiu obligatori).
    deleteTitle: 'Dona de baixa la formació',
    deleteBody:
      'La formació deixarà de comptar per a l’estat de la persona. Es conserva al registre amb el motiu.',
    deleteCta: 'Dona de baixa',
  },
} as const;
